module.exports = __webpack_public_path__ + "media/images/banner/japanesecrafts/ko-6a08657ebed89ec1705a7a5792153078.png";